/* eslint-disable no-empty-function */
import React, { FC } from 'react';
import { CheckboxCont, CheckboxInput, Checkmark } from './Checkbox.styles';

interface ICheckbox {
  checked: boolean;
  rounded?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

const Checkbox: FC<ICheckbox> = ({ checked, disabled, rounded = false, onClick = () => {} }) => (
  <CheckboxCont onClick={onClick} data-testid={checked ? 'checkedCheckbox' : 'uncheckedCheckbox'}>
    <CheckboxInput type="checkbox" disabled={disabled} checked={checked} onChange={() => {}} />
    <Checkmark disabled={disabled} rounded={rounded} />
  </CheckboxCont>
);

export default Checkbox;
